export interface ApiErrorInfo {
  code: string;
  message: string;
}

// 2xxレスポンスのボディがJSONとしてパースできなかった場合にもこの定数を使う（fetch自体は成功している）
export const SYSTEM_ERROR: ApiErrorInfo = {
  code: "SYSTEM_ERROR",
  message: "システムエラーが発生しました。時間をおいて再度お試しください。",
};

export const NETWORK_ERROR: ApiErrorInfo = {
  code: "NETWORK_ERROR",
  message: "サーバーに接続できませんでした。ネットワーク状態をご確認ください。",
};

// 未ログイン・認証切れ時にバックエンドが返すエラーコード（ログイン失敗のINVALID_CREDENTIALSとは別）
export const AUTH_ERROR_CODE = "AUTH_ERROR";

// 認証切れを検知したことを共通レイアウトへ知らせるイベント名（ログイン画面へリダイレクトさせる）
export const UNAUTHORIZED_EVENT = "bop:unauthorized";

export const isApiErrorResponse =(value: unknown): value is ApiErrorInfo => {
  return (
    typeof value === "object" &&
    value !== null &&
    typeof (value as ApiErrorInfo).code === "string" &&
    typeof (value as ApiErrorInfo).message === "string"
  );
};

export const parseApiError = async (res: Response): Promise<ApiErrorInfo> => {
  try {
    const data: unknown = await res.json();
    if (isApiErrorResponse(data)) {
      return data;
    }
  } catch {
    // JSON以外のレスポンス（whitelabelエラー等）はSYSTEM_ERRORにフォールバック
  }
  return SYSTEM_ERROR;
};
